"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceBasedSrcSet = exports.getImagesSrcSet = exports.sortImagesById = exports.getDeviceBasedImages = exports.deviceTypeNameMap = void 0;
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
exports.deviceTypeNameMap = {
    ['MOBILE']: `mobile`,
    ['DESKTOP']: `desktop`,
};
function getDeviceBasedImages(deviceType, images) {
    const device = exports.deviceTypeNameMap[deviceType];
    return images.filter(({ id }) => {
        return id.includes(device);
    });
}
exports.getDeviceBasedImages = getDeviceBasedImages;
const sortImagesById = (images) => {
    return images.sort((a, b) => {
        const af = parseFloat(a.id);
        const bf = parseFloat(b.id);
        if (af < bf)
            return -1;
        if (af > bf)
            return 1;
        return 0;
    });
};
exports.sortImagesById = sortImagesById;
function getImagesSrcSet(images, deviceType) {
    const device = exports.deviceTypeNameMap[deviceType];
    return images.length
        ? getDeviceBasedImages(deviceType, images)
            .map(({ url, id }) => `${url} ${id.slice(0, id.length - (device.length + 1))}`)
            .join(',')
        : undefined;
}
exports.getImagesSrcSet = getImagesSrcSet;
function useDeviceBasedSrcSet(resizedImages, src) {
    var _a, _b;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const deviceType = (mobile ? 'MOBILE' : 'DESKTOP');
    const deviceBasedImages = getDeviceBasedImages(deviceType, resizedImages);
    const images = (0, exports.sortImagesById)(deviceBasedImages);
    const srcSet = getImagesSrcSet(images, deviceType);
    const defaultSrc = ((_a = images[0]) === null || _a === void 0 ? void 0 : _a.url) || src || ((_b = resizedImages[0]) === null || _b === void 0 ? void 0 : _b.url);
    return {
        srcSet,
        defaultSrc,
    };
}
exports.useDeviceBasedSrcSet = useDeviceBasedSrcSet;
//# sourceMappingURL=useDeviceBasedSrcSet.js.map